import React from 'react';
// import pure from 'recompose/pure';
import SvgIcon from 'material-ui/SvgIcon';

let IconMainMenu = (props) => {
  props = Object.assign({viewBox: '0 0 30 30'}, props);
  return (
    <SvgIcon {...props}>
      <g>
        <path d="M7.4,9.2H2.6c-1,0-1.8-0.8-1.8-1.8V2.6c0-1,0.8-1.8,1.8-1.8h4.9c1,0,1.8,0.8,1.8,1.8v4.9
		C9.2,8.4,8.4,9.2,7.4,9.2z M2.6,2.2c-0.2,0-0.4,0.2-0.4,0.4v4.9c0,0.2,0.2,0.4,0.4,0.4h4.9c0.2,0,0.4-0.2,0.4-0.4V2.6
		c0-0.2-0.2-0.4-0.4-0.4H2.6z"/>
        <path d="M17.4,9.2h-4.9c-1,0-1.8-0.8-1.8-1.8V2.6c0-1,0.8-1.8,1.8-1.8h4.9c1,0,1.8,0.8,1.8,1.8v4.9
		C19.2,8.4,18.4,9.2,17.4,9.2z M12.6,2.2c-0.2,0-0.4,0.2-0.4,0.4v4.9c0,0.2,0.2,0.4,0.4,0.4h4.9c0.2,0,0.4-0.2,0.4-0.4V2.6
		c0-0.2-0.2-0.4-0.4-0.4H12.6z"/>
        <path d="M27.4,9.2h-4.9c-1,0-1.8-0.8-1.8-1.8V2.6c0-1,0.8-1.8,1.8-1.8h4.9c1,0,1.8,0.8,1.8,1.8v4.9
		C29.2,8.4,28.4,9.2,27.4,9.2z M22.6,2.2c-0.2,0-0.4,0.2-0.4,0.4v4.9c0,0.2,0.2,0.4,0.4,0.4h4.9c0.2,0,0.4-0.2,0.4-0.4V2.6
		c0-0.2-0.2-0.4-0.4-0.4H22.6z"/>
        <path d="M7.4,19.2H2.6c-1,0-1.8-0.8-1.8-1.8v-4.9c0-1,0.8-1.8,1.8-1.8h4.9c1,0,1.8,0.8,1.8,1.8v4.9
		C9.2,18.4,8.4,19.2,7.4,19.2z M2.6,12.2c-0.2,0-0.4,0.2-0.4,0.4v4.9c0,0.2,0.2,0.4,0.4,0.4h4.9c0.2,0,0.4-0.2,0.4-0.4v-4.9
		c0-0.2-0.2-0.4-0.4-0.4H2.6z"/>
        <path d="M17.4,19.2h-4.9c-1,0-1.8-0.8-1.8-1.8v-4.9c0-1,0.8-1.8,1.8-1.8h4.9c1,0,1.8,0.8,1.8,1.8v4.9
		C19.2,18.4,18.4,19.2,17.4,19.2z M12.6,12.2c-0.2,0-0.4,0.2-0.4,0.4v4.9c0,0.2,0.2,0.4,0.4,0.4h4.9c0.2,0,0.4-0.2,0.4-0.4v-4.9
		c0-0.2-0.2-0.4-0.4-0.4H12.6z"/>
        <path d="M27.4,19.2h-4.9c-1,0-1.8-0.8-1.8-1.8v-4.9c0-1,0.8-1.8,1.8-1.8h4.9c1,0,1.8,0.8,1.8,1.8v4.9
		C29.2,18.4,28.4,19.2,27.4,19.2z M22.6,12.2c-0.2,0-0.4,0.2-0.4,0.4v4.9c0,0.2,0.2,0.4,0.4,0.4h4.9c0.2,0,0.4-0.2,0.4-0.4v-4.9
		c0-0.2-0.2-0.4-0.4-0.4H22.6z"/>
        <path d="M7.4,29.2H2.6c-1,0-1.8-0.8-1.8-1.8v-4.9c0-1,0.8-1.8,1.8-1.8h4.9c1,0,1.8,0.8,1.8,1.8v4.9
		C9.2,28.4,8.4,29.2,7.4,29.2z M2.6,22.2c-0.2,0-0.4,0.2-0.4,0.4v4.9c0,0.2,0.2,0.4,0.4,0.4h4.9c0.2,0,0.4-0.2,0.4-0.4v-4.9
		c0-0.2-0.2-0.4-0.4-0.4H2.6z"/>
        <path d="M17.4,29.2h-4.9c-1,0-1.8-0.8-1.8-1.8v-4.9c0-1,0.8-1.8,1.8-1.8h4.9c1,0,1.8,0.8,1.8,1.8v4.9
		C19.2,28.4,18.4,29.2,17.4,29.2z M12.6,22.2c-0.2,0-0.4,0.2-0.4,0.4v4.9c0,0.2,0.2,0.4,0.4,0.4h4.9c0.2,0,0.4-0.2,0.4-0.4v-4.9
		c0-0.2-0.2-0.4-0.4-0.4H12.6z"/>
        <path d="M27.4,29.2h-4.9c-1,0-1.8-0.8-1.8-1.8v-4.9c0-1,0.8-1.8,1.8-1.8h4.9c1,0,1.8,0.8,1.8,1.8v4.9
		C29.2,28.4,28.4,29.2,27.4,29.2z M22.6,22.2c-0.2,0-0.4,0.2-0.4,0.4v4.9c0,0.2,0.2,0.4,0.4,0.4h4.9c0.2,0,0.4-0.2,0.4-0.4v-4.9
		c0-0.2-0.2-0.4-0.4-0.4H22.6z"/>
      </g>
    </SvgIcon>
  );
};
// IconMainMenu = pure(IconMainMenu);
IconMainMenu.displayName = 'IconMainMenu';
IconMainMenu.muiName = 'SvgIcon';

export default IconMainMenu;



// WEBPACK FOOTER //
// ./src/components/Icons/IconMainMenu.js